module.exports = require('./helpers/bundle-url').getBundleURL('aK4Nu') + "Wave3.ea6ec40e.svg";